<template>
  <transition name="system-dialog-fade">
    <div
      v-if="visible"
      class="system-dialog-overlay"
      @click.self="close"
    >
      <div class="system-dialog" role="dialog" :aria-label="computedTitle">
        <header class="system-dialog__header">
          <h3 v-if="title" v-html="title"/>
          <button type="button" class="system-dialog__close" @click="close" aria-label="Close dialog">
            &times;
          </button>
        </header>
        <section class="system-dialog__body" v-html="content"/>
        <footer class="system-dialog__footer">
          <button type="button" class="system-dialog__button" @click="close">{{ closeText }}</button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import EventBus from "../api/event-bus";

export default {
  name: "SystemDialog",
  data() {
    return {
      visible: false,
      title: "",
      content: "",
      closeText: "Close",
    };
  },
  computed: {
    computedTitle() {
      return this.title || "System message";
    }
  },
  mounted() {
    EventBus.$on("system-dialog:open", this.open);
    EventBus.$on("system-dialog:close", this.close);
    document.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    EventBus.$off("system-dialog:open", this.open);
    EventBus.$off("system-dialog:close", this.close);
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    open(payload = {}) {
      this.title = payload.title || "";
      this.content = payload.content || "";
      this.closeText = payload.closeText || "Close";
      this.visible = true;
    },
    close() {
      if (!this.visible) {
        return;
      }
      this.visible = false;
      EventBus.$emit("system-dialog:closed");
    },
    handleKeydown(event) {
      if (event.key === "Escape" && this.visible) {
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.system-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  padding: 24px;
  box-sizing: border-box;
}

.system-dialog {
  width: min(480px, 100%);
  max-height: calc(100vh - 48px);
  max-height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 24px 48px rgba(25, 30, 46, 0.25);
  overflow: hidden;
  text-align: left;
}

.system-dialog__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 auto;
  padding: 20px 24px 0 24px;
  gap: 16px;
}

.system-dialog__header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1b1b1f;
}

.system-dialog__close {
  border: none;
  background: #333;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  transition: background 0.2s ease, transform 0.2s ease;
}

.system-dialog__close:hover {
  background: #1f1f1f;
  transform: scale(1.05);
}

.system-dialog__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 20px 24px 0 24px;
  font-size: 16px;
  line-height: 1.6;
  color: #444;
}

.system-dialog__footer {
  flex: 0 0 auto;
  padding: 24px;
  display: flex;
  justify-content: flex-end;
}

.system-dialog__button {
  padding: 10px 24px;
  border-radius: 8px;
  border: none;
  background: #333;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.system-dialog__button:hover {
  background: #1f1f1f;
  transform: translateY(-1px);
}

.system-dialog-fade-enter-active,
.system-dialog-fade-leave-active {
  transition: opacity 0.25s ease;
}

.system-dialog-fade-enter,
.system-dialog-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/SystemDialog.vue